import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GotoSourceButton } from '../../buttons-bar';
import Button from '../../button';
import { useWindowSize } from '../../../lib/hooks';
import { hideReport, showModal, showReport } from '../../../actions/modal';
import { REPORT_MODAL } from '../../../containers/modal/modal-types';
import Stack from '../../stack';
import { SOURCES } from '../../../constants/sources';

export const ActionButtons = ({
    bookId,
    homeworkId,
    googleCourseWorkId,
    hideReport,
    isLtiLaunch,
    isOpenAssignment,
    reportOpened,
    showModal,
    showReport,
    source,
}) => {
    const { innerWidth } = useWindowSize();
    const isMobile = innerWidth < 767;

    const handleClickReport = () => {
        if (isMobile) {
            showModal(REPORT_MODAL);
            showReport();
            return;
        }

        if (reportOpened) {
            hideReport();
            return;
        }

        showReport();
    };

    const backSource = !!googleCourseWorkId ? SOURCES.GOOGLE_CLASSROOM : source;

    return (
        <Stack gap="base" direction={['vertical', 'horizontal', 'horizontal']}>
            {!isLtiLaunch && (
                <GotoSourceButton
                    source={backSource}
                    bookId={bookId}
                    homeworkId={!isOpenAssignment ? homeworkId : undefined}
                    type="primary"
                />
            )}
            <Button type="tertiary" onClick={handleClickReport} size="small">
                {'Contattaci'}
            </Button>
        </Stack>
    );
};

ActionButtons.propTypes = {
    bookId: PropTypes.string,
    homeworkId: PropTypes.string,
    googleCourseWorkId: PropTypes.string,
    hideReport: PropTypes.func,
    isLtiLaunch: PropTypes.bool,
    isOpenAssignment: PropTypes.bool,
    reportOpened: PropTypes.bool,
    showModal: PropTypes.func,
    showReport: PropTypes.func,
    source: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        bookId: state.application.bookId,
        homeworkId: state.homework.id,
        googleCourseWorkId: state.application.googleCourseWorkId,
        isLtiLaunch: state.application.isLtiLaunch,
        isOpenAssignment: state.application.isOpenAssignment,
        reportOpened: state.modal.showReport,
        source: state.application.source,
    };
};

const actionCreators = {
    showModal,
    showReport,
    hideReport,
};

export default connect(mapStateToProps, actionCreators)(ActionButtons);
